import "core-js/modules/es.array.reverse.js";
var _class, _CartoMapV3Stratum, _class2, _descriptor, _descriptor2, _CartoMapV3CatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { featureCollection } from "@turf/helpers";
import i18next from "i18next";
import { computed, makeObservable, observable, runInAction } from "mobx";
import RequestErrorEvent from "terriajs-cesium/Source/Core/RequestErrorEvent";
import URI from "urijs";
import { toFeatureCollection } from "../../../Core/GeoJson";
import { isJsonNumber, isJsonObject, isJsonString, isJsonStringArray } from "../../../Core/Json";
import loadJson from "../../../Core/loadJson";
import Result from "../../../Core/Result";
import TerriaError, { networkRequestError } from "../../../Core/TerriaError";
import GeoJsonMixin from "../../../ModelMixins/GeojsonMixin";
import CartoMapV3CatalogItemTraits from "../../../Traits/TraitsClasses/CartoMapV3CatalogItemTraits";
import { GeoJsonTraits } from "../../../Traits/TraitsClasses/GeoJsonTraits";
import TableStyleTraits from "../../../Traits/TraitsClasses/Table/StyleTraits";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
let CartoMapV3Stratum = (_class = (_CartoMapV3Stratum = class CartoMapV3Stratum extends LoadableStratum(GeoJsonTraits) {
  constructor(catalogItem) {
    super();
    this.catalogItem = catalogItem;
    makeObservable(this);
  }
  static load(item) {
    return new CartoMapV3Stratum(item);
  }
  duplicateLoadableStratum(newModel) {
    return new CartoMapV3Stratum(newModel);
  }

  // Hide "cartodb_id" style
  get styles() {
    return [createStratumInstance(TableStyleTraits, {
      id: "cartodb_id",
      hidden: true
    })];
  }
}, _defineProperty(_CartoMapV3Stratum, "stratumName", "cartoMapV3Stratum"), _CartoMapV3Stratum), _applyDecoratedDescriptor(_class.prototype, "styles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "styles"), _class.prototype), _class);
StratumOrder.addLoadStratum(CartoMapV3Stratum.stratumName);
let CartoMapV3CatalogItem = (_class2 = (_CartoMapV3CatalogItem = class CartoMapV3CatalogItem extends GeoJsonMixin(CreateModel(CartoMapV3CatalogItemTraits)) {
  constructor(id, terria, sourceReference) {
    super(id, terria, sourceReference);
    _initializerDefineProperty(this, "geoJsonUrls", _descriptor, this);
    // Commented out as we don't support tileJSON yet
    // @observable
    // mvtTileJsonUrls: string[] = [];
    _initializerDefineProperty(this, "geoJsonSize", _descriptor2, this);
    makeObservable(this);
    if (this.strata.get(CartoMapV3Stratum.stratumName) === undefined) {
      runInAction(() => {
        this.strata.set(CartoMapV3Stratum.stratumName, new CartoMapV3Stratum(this));
      });
    }
  }
  get type() {
    return CartoMapV3CatalogItem.type;
  }
  get typeName() {
    return i18next.t("models.carto-v3.name");
  }
  async forceLoadMetadata() {
    let response;

    // If cartoQuery is defined - use Query API (https://api-docs.carto.com/#8f2020d9-edf3-4b50-ae58-9edeaa34613c)
    if (this.cartoQuery) {
      var _await$callCartoApi;
      const url = new URI(this.baseUrl).path("").path("v3/maps/".concat(this.connectionName, "/query"));
      response = (_await$callCartoApi = await callCartoApi(url.toString(), this.accessToken, {
        q: this.cartoQuery,
        geo_column: this.cartoGeoColumn
      })) === null || _await$callCartoApi === void 0 ? void 0 : _await$callCartoApi.throwIfError();
    }
    // If cartoTableName is defined - use Table API (https://api-docs.carto.com/#6a05d4d7-c6a1-4635-a8de-c91fa5e77fda)
    else if (this.cartoTableName) {
      var _this$cartoColumns, _await$callCartoApi2;
      const url = new URI(this.baseUrl).path("").path("v3/maps/".concat(this.connectionName, "/table")).query({
        name: this.cartoTableName,
        columns: (_this$cartoColumns = this.cartoColumns) === null || _this$cartoColumns === void 0 ? void 0 : _this$cartoColumns.join(","),
        geo_column: this.cartoGeoColumn
      });
      response = (_await$callCartoApi2 = await callCartoApi(url.toString(), this.accessToken)) === null || _await$callCartoApi2 === void 0 ? void 0 : _await$callCartoApi2.throwIfError();
    } else {
      throw new TerriaError({
        title: "Invalid Carto V3 config",
        message: "`cartoQuery` or `cartoTableName` must be defined"
      });
    }
    let geoJsonUrls = [];
    // Commented out as we don't support tileJSON yet
    // let mvtTileJsonUrls: string[] = [];

    if (response && isJsonObject(response.geojson) && isJsonStringArray(response.geojson.url)) {
      geoJsonUrls = response.geojson.url;
    }

    // Commented out as we don't support tileJSON yet
    // if (
    //   response &&
    //   isJsonObject(response.tilejson) &&
    //   isJsonStringArray(response.tilejson.url)
    // ) {
    //   mvtTileJsonUrls = response.tilejson.url;
    // }

    if (geoJsonUrls.length === 0 /*&& mvtTileJsonUrls.length === 0*/) {
      throw TerriaError.from("No GeoJSON found.");
    }
    runInAction(() => {
      var _response;
      if (response && isJsonNumber((_response = response) === null || _response === void 0 ? void 0 : _response.size)) {
        this.geoJsonSize = response.size;
      }
      this.geoJsonUrls = geoJsonUrls;
      // Commented out as we don't support tileJSON yet
      // this.mvtTileJsonUrls = mvtTileJsonUrls;
    });
  }
  async forceLoadGeojsonData() {
    if (this.geoJsonUrls.length === 0) throw TerriaError.from("No GeoJSON URL found for Carto table");
    let jsonData = undefined;

    // Download all geoJson files
    const geojsonResponses = await Promise.all(this.geoJsonUrls.map(async url => {
      var _await$callCartoApi3;
      jsonData = (_await$callCartoApi3 = await callCartoApi(url, this.accessToken)) === null || _await$callCartoApi3 === void 0 ? void 0 : _await$callCartoApi3.throwIfError();
      if (jsonData === undefined) {
        throw new TerriaError({
          title: "Failed to load GeoJSON",
          message: "Failed to load GeoJSON URL ".concat(url)
        });
      }
      if (isJsonObject(jsonData, false) && typeof jsonData.type === "string") {
        // Actual geojson
        const fc = toFeatureCollection(jsonData);
        if (fc) return fc;
      }
      throw new TerriaError({
        title: "Failed to load GeoJSON",
        message: "Invalid response from GeoJSON URL ".concat(url, ":\n\n\n          ```\n          ").concat(JSON.stringify(jsonData), "\n          ```")
      });
    }));

    // NOTE: Commented out until we add tileJson/mvt support
    // Download all tileJson files
    // const tilejsonResponses = await Promise.all(
    //   this.mvtTileJsonUrls.map(async (url) => {
    //     jsonData = await loadJson(url, {
    //       Authorization: `Bearer ${this.accessToken}`
    //     });

    //     if (jsonData === undefined) {
    //       throw new TerriaError({
    //         title: "Failed to load GeoJSON",
    //         message: `Failed to load GeoJSON URL ${url}`
    //       });
    //     }

    //     if (isJsonObject(jsonData, false)) {
    //       return jsonData;
    //     }

    //     throw new TerriaError({
    //       title: "Failed to load GeoJSON",
    //       message: `Invalid response from GeoJSON URL ${url}:\n\n
    //       \`\`\`
    //       ${JSON.stringify(jsonData)}
    //       \`\`\``
    //     });
    //   })
    // );

    // Merge all geojson responses into a combined feature collection
    const combinedFeatureCollection = featureCollection([]);
    geojsonResponses.forEach(fc => {
      for (let i = 0; i < fc.features.length; i++) {
        combinedFeatureCollection.features.push(fc.features[i]);
      }
    });
    return combinedFeatureCollection;
  }
}, _defineProperty(_CartoMapV3CatalogItem, "type", "carto-v3"), _CartoMapV3CatalogItem), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "geoJsonUrls", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "geoJsonSize", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { CartoMapV3CatalogItem as default };
/** Wrap loadJson calls to handle Carto API error messages */
async function callCartoApi(url, auth, body) {
  try {
    return new Result(await loadJson(url, auth ? {
      Authorization: "Bearer ".concat(auth)
    } : {}, body));
  } catch (e) {
    if (e instanceof RequestErrorEvent) {
      try {
        const jsonResponse = isJsonString(e.response) ? JSON.parse(e.response) : e.response;
        if (isJsonObject(jsonResponse) && isJsonString(jsonResponse.error)) {
          var _cartoError$message;
          const cartoError = jsonResponse;
          return Result.error(networkRequestError(TerriaError.from(e, {
            title: "Error from Carto API",
            message: (_cartoError$message = cartoError.message) !== null && _cartoError$message !== void 0 ? _cartoError$message : cartoError.error,
            importance: -1
          })));
        }
      } catch (_unused) {}
    }
    return Result.error(e);
  }
}